import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import { findSysDictionary } from '@/api/sysDictionary';
export var dictionary = {
  namespaced: true,
  state: {
    dictionaryMap: {}
  },
  mutations: {
    setDictionaryMap: function setDictionaryMap(state, dictionaryMap) {
      state.dictionaryMap = _objectSpread(_objectSpread({}, state.dictionaryMap), dictionaryMap);
    }
  },
  actions: {
    // 从后台获取动态路由
    getDictionary: function getDictionary(_ref, type) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var commit, state, res, dictionaryMap, dict;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              if (!state.dictionaryMap[type]) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return", state.dictionaryMap[type]);
            case 1:
              _context.next = 2;
              return findSysDictionary({
                type: type
              });
            case 2:
              res = _context.sent;
              if (!(res.code === 0)) {
                _context.next = 3;
                break;
              }
              dictionaryMap = {};
              dict = [];
              res.data.resysDictionary.sysDictionaryDetails && res.data.resysDictionary.sysDictionaryDetails.map(function (item) {
                dict.push({
                  label: item.label,
                  value: item.value
                });
              });
              dictionaryMap[res.data.resysDictionary.type] = dict;
              commit('setDictionaryMap', dictionaryMap);
              return _context.abrupt("return", state.dictionaryMap[type]);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  getters: {
    getDictionary: function getDictionary(state) {
      return state.dictionaryMap;
    }
  }
};